import client from './client';

// Get all allowances with optional filters
export const getAllowances = async (data) => {
  const res = await client.post('/allowances/filter', data);
  return res.data;
};

// Get personnel allowances for multiple employees (bulk)
export const getPersonnelAllowancesBulk = async (employeeIds, isActive = true) => {
  const res = await client.post('/allowances/personnel/bulk', {
    employee_ids: employeeIds,
    is_active: isActive
  });
  return res.data;
};

// Create a new allowance
export const createAllowance = async (allowanceData) => {
  const res = await client.post('/allowances', allowanceData);
  return res.data;
};

// Update an allowance
export const updateAllowance = async (allowanceId, allowanceData) => {
  const res = await client.put(`/allowances/${allowanceId}`, allowanceData);
  return res.data;
};

// Delete an allowance
export const deleteAllowance = async (allowanceId) => {
  const res = await client.delete(`/allowances/${allowanceId}`);
  return res.data;
};

// Assign allowance to personnel
export const assignToPersonnel = async (allowanceId, employeeIds) => {
  const res = await client.post(`/allowances/${allowanceId}/assign/personnel`, {
    employee_ids: employeeIds
  });
  return res.data;
};

// Assign allowance to store
export const assignToStore = async (allowanceId, storeNames) => {
  const res = await client.post(`/allowances/${allowanceId}/assign/store`, {
    store_names: storeNames
  });
  return res.data;
};

// Assign allowance to group
export const assignToGroup = async (allowanceId, groupIds) => {
  const res = await client.post(`/allowances/${allowanceId}/assign/group`, {
    group_ids: groupIds
  });
  return res.data;
};

// Remove personnel assignment
export const removePersonnelAssignment = async (allowanceId, employeeId) => {
  const res = await client.delete(`/allowances/${allowanceId}/assign/personnel/${employeeId}`);
  return res.data;
};

// Remove store assignment
export const removeStoreAssignment = async (allowanceId, storeName) => {
  const res = await client.delete(`/allowances/${allowanceId}/assign/store/${storeName}`);
  return res.data;
};

// Remove group assignment
export const removeGroupAssignment = async (allowanceId, groupId) => {
  const res = await client.delete(`/allowances/${allowanceId}/assign/group/${groupId}`);
  return res.data;
};

// Get allowances for payroll (with hierarchy resolution)
export const getAllowancesForPayroll = async (params) => {
  const res = await client.get('/allowances/for-payroll', { params });
  return res.data;
};

// Get assignments for an allowance
export const getAllowanceAssignments = async (allowanceId) => {
  const res = await client.get(`/allowances/${allowanceId}/assignments`);
  return res.data;
};

// Assign allowances to payrolls
// options.replaceGroupAllowances: when true, overwrite group-assigned allowances with store allowances
// options.allowanceType: 'store' | 'group' - only process this specific type (optimization)
// options.groupId: when allowanceType is 'group', pass groupId to let backend resolve payrolls from group stores (no payroll_ids needed)
export const assignAllowancesToPayrolls = async (allowanceIds, payrollIds, options = {}) => {
  const body = {
    allowance_ids: allowanceIds,
    payroll_ids: payrollIds ?? []
  };
  if (options.replaceGroupAllowances === true) {
    body.replace_group_allowances = true;
  }
  if (options.allowanceType === 'store' || options.allowanceType === 'group') {
    body.allowance_type = options.allowanceType;
  }
  if (options.allowanceType === 'group' && options.groupId) {
    body.group_id = options.groupId;
  }
  const res = await client.post('/payroll/assign-allowances', body);
  return res.data;
};

// Clear all allowances from payrolls
// clearSource: 'group' | 'store' | 'personnel' | undefined - only clear allowances from that source
// When clearing 'personnel', store/group allowances will be automatically applied if they exist
// When clearSource is 'group', pass options.groupId to let backend resolve payrolls from group stores (payrollIds can be empty)
export const clearAllowancesFromPayrolls = async (payrollIds, clearSource = undefined, options = {}) => {
  const body = {
    payroll_ids: payrollIds ?? []
  };
  if (clearSource === 'group' || clearSource === 'store' || clearSource === 'personnel') {
    body.clear_source = clearSource;
  }
  if (clearSource === 'group' && options.groupId) {
    body.group_id = options.groupId;
  }
  const res = await client.post('/payroll/clear-allowances', body);
  return res.data;
};

